<template>
  <div class="home">
    <my-head :title="title" :subtitle="subtitle" v-on:goBack="handleBack" :isShowLogo="isShowLogo" @getFooter="getFooter" :back="false">
      <!-- <template v-slot:carousel>
        <carousel ></carousel>
      </template> -->
    </my-head>
    <carousel ></carousel>
    
    <div class="listBox">
      <div class="selectBox">
        <van-dropdown-menu id="mydropdown" active-color="#008d44">
          <van-dropdown-item v-model="value" :options="option" @change="handleChange" />
        </van-dropdown-menu>
      </div>
      <div class="list">
        <div
          class="listItem"
          v-for="(item) in dataList"
          :key="item.id"
          @click="hanhdleClick(item.id)"
        >
          <div class="itemInfo">
            <span>{{item.date}}</span>&nbsp;&nbsp;
            <span>{{item.name}}</span>
          </div>
          <div class="leftBox iconBox">
            <van-icon name="arrow" size="16px" color="white" />
          </div>
        </div>
      </div>
    </div>
    <div class="pageBox" v-if="total">
      <div class="leftBox iconBox" @click="prevPage">
        <van-icon name="arrow-left" size="16px" />
      </div>
      <div class="page">{{pageNo}}/{{pageCount}}</div>
      <div class="leftBox iconBox" @click="nextPage">
        <van-icon name="arrow" size="16px" />
      </div>
    </div>
    <div id="footer" v-if="footer">
      <span>{{footer}} </span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { GetMatch, GetCarouselImg, pageSetting, GetYears } from "@/request/api";
import myHead from "@/components/myHead.vue";
import Carousel from "@/components/Carousel.vue";
import { Icon, DropdownMenu, DropdownItem, Form, Pagination,Toast  } from "vant";

export default {
  name: "Home",
  data() {
    return {
      isShowLogo: 1,
      title: "",
      subtitle: "",
      value: '',
      // option: [{ text: "2020年", value: 2020 },{ text: "2021年", value: 2021 }],
      option: [],
      dataList: [],
      pageNo: 1,
      pageCount: "",
      pageSize: 10,
      total:"",
      footer:"",
      // itemList: []
      //  itemList: [],
      //  advBgImage: ""
    };
  },
  components: {
    [Icon.name]: Icon,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Pagination.name]: Pagination,
    myHead,
    Carousel
  },
  mounted() {
    console.log('isShowLogo', this.isShowLogo );

    // this.GetMatch();
    this.GetYears();
  },
  methods: {
    GetYears: function(){
      GetYears().then(res => {
        if (res.success) {
          let year = res.data.sort()
          this.option = []
           for (var i = 0; i < year.length; i++) {
            this.option.push({ text: year[i]+"年", value: year[i] })
          }
          let thisYear = new Date().getFullYear() + ''
          this.value = thisYear
          this.handleChange(this.value)

        }
      });
    },
    GetMatch:function(){
      const { value, pageNo, pageSize } = this;
      console.log(pageNo, pageSize)
      this.dataList = [];
      GetMatch(value, { pageNo, pageSize }).then(res => {
        //设置标题图片和起始年限
        if (res.success) {
          this.dataList = res.data.records;
          this.pageCount = res.data.pages;
          this.total = res.data.total
          for (var i = 0; i < this.dataList.length; i++) {
            this.dataList[i].date = this.getFormatDate(
              res.data.records[i].startDate
            );
          }
        }
      });
    },
    // GetCarouselImg: function(){

    // },
    getFooter:function(val){
      this.footer = val
    },
    handleBack: () => {
      console.log("返回");
      this.$router.go(-1);
    },
    hanhdleClick: function(id) {
      this.$router.push({
        path: `/detail/${id}`
      });
    },
    prevPage:function(){
      let { pageNo, pageCount } = this
      if(pageNo==1){
        this.$toast('已经是首页啦');
      }else{
        this.pageNo = --pageNo
        console.log(this.pageNo)

        this.GetMatch()
      }
    },
    nextPage:function(){
      let { pageNo, pageCount } = this
      if(pageNo==pageCount){
        this.$toast('已经是尾页啦');
      }else{
        this.pageNo = ++pageNo
        console.log(this.pageNo)

        this.GetMatch()
      }
    },
    handleChange: function(value) {
      
      this.value = value;
      this.pageNo=1
      this.pageCount=""
      this.pageSize=10
      this.total=""
      this.GetMatch()
    },
    //获取时间函数
    getFormatDate: function(date) {
      var enMonth = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
      ];
      var date = new Date(date);
      var year = date.getFullYear();
      var month = date.getMonth();
      var nowDate = date.getDate();
      if (nowDate >= 0 && nowDate <= 9) {
        nowDate = "0" + nowDate;
      }
      // var newDate = year + seperator + month + seperator + nowDate;
      var newDate = nowDate + " " + enMonth[month] + " " + year;
      return newDate;
    }
  }
};
</script>

<style lang="less">

.home .selectBox {
  padding: 10px 16px;
  background: #008d44;
  .van-dropdown-menu__bar {
    height: 40px;
  }
  .van-dropdown-menu__title {
    font-size: 14px !important;
  }
  .van-cell__title {
    font-size: 12px !important;
  }
  .van-popup--top {
    left: 20px;
    right: 20px;
    width: auto;
  }
}
// 修改myhead子组件样式
// .home .myHead-warpper {
//   height: 225px;
// .carousel-wrap {
//   bottom: 0;
// }
//   .flexBox {
//     height: 40px;
//     top: 90px;
//   }
//    .myHead{
//     align-items: baseline;
//     .logoBox {
//       width: 60px;
//       height: 60px;
//         margin-top:15px;
//     }
//    }
// }
 @media screen and (min-width: 920px) {
//  .home .myHead-warpper {
  //  height: 590px;
  //  height: 645px;

 }
//  .home .myHead-warpper {
//   .flexBox {
//     top: 130px;
//   }
//    .myHead{
//     .logoBox {
//       width: 100px;
//       height: 100px;
//         margin-top:15px;
//     }
//    }
// }
// }

</style>
<style scoped lang="less">
.listItem {
  background: #008d44;
  line-height: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-left: 20px;
  padding-right: 10px;
  color: white;
  position: relative;
  &:hover{
      cursor:pointer
  }
  &:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 16px;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  .itemInfo {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
}
.pageBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 44px;
}
.iconBox {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
    &:hover{
      cursor:pointer
  }
}
</style>
